import { PaStatus } from "../../../../enums/paStatus";

/** Display label when response_status is unset. */
export const RISA_IN_PROGRESS_OUTCOME_LABEL = "RISA In Progress";

/** Display label when response_status is Pending. */
export const PENDING_WITH_INSURANCE_OUTCOME_LABEL = "Pending With Insurance";

/**
 * Maps raw `response_status` to the Outcome column label on Astera Oncology External.
 *
 * @input responseStatus - Raw response_status from the row (null/empty when unset)
 * @return string: Label shown in the Outcome badge
 */
export const getAsteraOutcomeDisplayText = (
  responseStatus: string | null | undefined,
): string => {
  if (responseStatus == null || responseStatus === "") {
    return RISA_IN_PROGRESS_OUTCOME_LABEL;
  }
  if (responseStatus === PaStatus.PENDING) {
    return PENDING_WITH_INSURANCE_OUTCOME_LABEL;
  }
  return responseStatus;
};
